import React from "react";
import { useAdCpt1 } from "@/hooks/adCpt/homeVendor";
import { getMainDomain } from "@/utils/getMainDomain";
import { Skeleton } from "antd-mobile";
import Sunrise from "@/components/common/Sunrise";
import { homeAtom } from "@/atoms/home";
import ChartData from "./ChartData";

// 骨架屏样式常量
const SKELETON_STYLES = {
  aqi: { "--width": "100%", "--height": "188px", "--border-radius": "10px" },
  current1: { "--width": "100%", "--height": "121px", "--border-radius": "10px" },
};

const SunriseSunset: React.FC<any> = () => {
  const adPosition23 = useAdCpt1("position-23");
  const homeData = useAtomValue(homeAtom);
  const { aqi = {}, current = {} } = homeData?.data ?? {};
  const mainDomain = getMainDomain();
  const aqiContent = isEmptyType(aqi) ? <Skeleton animated style={SKELETON_STYLES.aqi} /> : <ChartData />;
  const sunriseContent = isEmptyType(current) ? <Skeleton animated style={SKELETON_STYLES.current1} /> : <Sunrise />;
  if (mainDomain === "24hweather.com") {
    return (
      <>
        {sunriseContent}
        {aqiContent}
      </>
    );
  }
  return (
    <>
      {aqiContent}
      <div data-position="position-23">{adPosition23}</div>
      {sunriseContent}
    </>
  );
};

export default SunriseSunset;
